export class NgeCdnPaths {
    public static readonly baseCdnUrl = 'https://salrsusncaarconcourse01.blob.core.windows.net/testfileversioning/';
    public static readonly bulkUploadDocs = NgeCdnPaths.baseCdnUrl + 'Bulk Upload Templates.zip';
}